import React, { useState } from "react";
import { Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useIntl } from "react-intl";
import { useSnackbar } from "notistack";
import { downloadAuthenticatedFile } from "network/download-authenticated-file";

/** "Club Atlético Ñandú" + "players" -> "club-atletico-nandu-players.csv" */
export const csvFilename = (name, suffix) => {
  const slug = String(name || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  return `${slug || "organizer"}-${suffix}.csv`;
};

const CsvDownloadButton = ({ url, filename, user, labelId, variant = "outlined", size = "small", disabled = false, ...rest }) => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [busy, setBusy] = useState(false);

  const handleClick = () => {
    setBusy(true);
    downloadAuthenticatedFile({ url, user, filename, accept: "text/csv" })
      .catch(() => enqueueSnackbar(intl.formatMessage({ id: "league.csv.exportError" }), { variant: "error" }))
      .finally(() => setBusy(false));
  };

  return (
    <Button variant={variant} size={size} startIcon={<FileDownloadIcon />} onClick={handleClick} disabled={disabled || busy} {...rest}>
      {intl.formatMessage({ id: labelId })}
    </Button>
  );
};

export default CsvDownloadButton;
